function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import withStyles from 'isomorphic-style-loader/withStyles';
import PropTypes from 'prop-types';
import { calculateData } from 'helpers/kpi';
import { Indicators } from '../../../modules/Kpi';
import styles from './Header.pcss';
var _React_Component;
class Summary extends (_React_Component = React.Component) {
    static getDerivedStateFromProps(props) {
        const { readings } = props;
        return _object_spread({}, calculateData(readings));
    }
    render() {
        const { readings, daysWithReadings, daysWithoutReadings } = this.props;
        const { preMealReadings, postMealReadings } = this.state;
        return /*#__PURE__*/ _jsx("div", {
            className: styles.dailyLogReport__summary,
            children: /*#__PURE__*/ _jsx(Indicators, {
                readings: readings,
                preMealReadings: preMealReadings,
                postMealReadings: postMealReadings,
                daysWithReadings: daysWithReadings,
                daysWithoutReadings: daysWithoutReadings,
                className: styles.dailyLogReport__kpis
            })
        });
    }
    constructor(props){
        super(props);
        this.state = {
            preMealReadings: 0,
            postMealReadings: 0
        };
    }
}
_define_property(Summary, "propTypes", {
    // Explicit props
    standards: PropTypes.shape({
        maxValue: PropTypes.number.isRequired,
        preMeal: PropTypes.shape({
            highThreshold: PropTypes.number.isRequired,
            lowThreshold: PropTypes.number.isRequired
        }),
        postMeal: PropTypes.shape({
            highThreshold: PropTypes.number.isRequired,
            lowThreshold: PropTypes.number.isRequired
        })
    }),
    readings: PropTypes.array,
    daysWithReadings: PropTypes.number,
    daysWithoutReadings: PropTypes.number
});
export default withStyles(styles)(Summary);
